var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0527 7.94681C15.7428 7.63687 15.2402 7.63687 14.9303 7.94681L7.94618 14.9309C7.63624 15.2409 7.63624 15.7434 7.94618 16.0533C8.25612 16.3633 8.75864 16.3633 9.06857 16.0533L16.0527 9.0692C16.3626 8.75926 16.3626 8.25675 16.0527 7.94681Z",
    fill: "#5B6670"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9473 7.94681C8.25724 7.63687 8.75975 7.63687 9.06969 7.94681L16.0538 14.9309C16.3638 15.2409 16.3638 15.7434 16.0538 16.0533C15.7439 16.3633 15.2414 16.3633 14.9314 16.0533L7.9473 9.0692C7.63736 8.75926 7.63736 8.25675 7.9473 7.94681Z",
    fill: "#5B6670"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.5,
    stroke: "#5B6670",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelCircle);
export default __webpack_public_path__ + "static/media/cancel-circle.d57b76b858864cce1091580d320887e0.svg";
export { ForwardRef as ReactComponent };